import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { LoadingState } from '@/components/app/LoadingState';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <LoadingState label="Checking session" />;
  if (status === 'unauthenticated') {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <>{children}</>;
}

export type AdminPermission =
  | 'notifications:read'
  | 'notifications:write'
  | 'notifications:kill'
  | 'users:write'
  | 'teams:write'
  | 'migrations:run'
  | 'system:write';

// Role model is not implemented server-side yet (ADR-022 placeholder).
// Until it ships, every authenticated admin has every permission.
export function hasPermission(_permission: AdminPermission): boolean {
  return true;
}

interface RoleGuardProps {
  permission: AdminPermission;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export function RoleGuard({ permission, fallback = null, children }: RoleGuardProps) {
  if (!hasPermission(permission)) return <>{fallback}</>;
  return <>{children}</>;
}
